import React from 'react';
import styled from 'styled-components';
import { SecondaryProductSelectListPropsType } from '../../model/index';
import { SecondaryProductDisplayView } from '../secondary-product-display';

export function SecondaryProductSelectList({
  secondaryProductKeys,
  selectedSecondaryProductKey,
  setSelectedSecondaryProductKey
}: SecondaryProductSelectListPropsType) {
  return (
    <SecondaryProductSelectionListContainer>
      {secondaryProductKeys.length > 0 &&
        secondaryProductKeys.map((productKey: string, index) => (
          <SecondaryProductDisplayView
            btnId={index}
            key={productKey}
            productKey={productKey}
            selected={selectedSecondaryProductKey === productKey}
            onSelect={() => {
              if (selectedSecondaryProductKey === productKey) {
                setSelectedSecondaryProductKey('');
              } else {
                setSelectedSecondaryProductKey(productKey);
              }
            }}
          />
        ))}
    </SecondaryProductSelectionListContainer>
  );
}

export const SecondaryProductSelectionListContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
